export default __webpack_public_path__ + "static/generative_ai_subbanner-3e8ef3d1330e955d8080a9d952f9406d.webp";